module.exports = __webpack_public_path__ + "img/process.3a5bc77b.jpg";